<template>
  <div class="accordion box" role="presentation">
    <slot
      v-bind="{
        multiple,
        readOnly
      }"
    ></slot>
  </div>
</template>

<script>
export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.accordion {
  padding: 0;

  /* div:not(:last-child) {
    // border-bottom: 1px solid rgba(10, 10, 10, 0.1);
  }
 */
  div:last-child .accordion-item-details {
    border-radius: 5px;
  }
}
</style>
